import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const DoubleCheckCircle: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7134 5.46877C11.9311 5.20586 12.3058 5.18235 12.5508 5.41602C12.7959 5.64972 12.8178 6.05177 12.6 6.31469L8.48217 11.2867C8.26555 11.5479 7.89273 11.5727 7.64747 11.3424L5.58855 9.40877C5.34208 9.1771 5.31711 8.77474 5.5329 8.51011C5.74878 8.24559 6.12374 8.21887 6.37039 8.45039L7.98599 9.96807L11.7134 5.46877ZM3.38866 8.77582C3.59913 8.50628 3.97301 8.4705 4.22429 8.6962L5.80836 10.1203C6.05962 10.3462 6.09289 10.7473 5.88255 11.017C5.67206 11.2867 5.29731 11.3225 5.046 11.0966L3.46193 9.6725C3.21093 9.44658 3.17828 9.04538 3.38866 8.77582ZM9.33633 5.21698C9.55237 4.9524 9.92819 4.92645 10.1747 5.15826C10.4209 5.39014 10.4454 5.7925 10.2295 6.05693L8.40797 8.28718C8.19195 8.55172 7.81705 8.57865 7.57049 8.34689C7.32398 8.11512 7.29895 7.71279 7.51484 7.44822L9.33633 5.21698Z"
      fill="currentColor"
    />
    <path
      d="M8 15.0002C11.866 15.0002 15 11.8662 15 8.00018C15 4.13419 11.866 1.00018 8 1.00018C4.13401 1.00018 1 4.13419 1 8.00018C1 11.8662 4.13401 15.0002 8 15.0002Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
